<template>
  <button
    :class="{'btn-ripple': true, disabled}"
    @click="(!disabled && action(value, disabled)) || disabledAction()"
  >
    {{text}}
    <div class="ripple-container"></div>
  </button>
</template>

<script>
export default {
  name: 'donapp-button',
  props: {
    action: {
      type: Function
    },
    disabledAction: {
      type: Function,
      default: () => console.log('button disabled')
    },
    text: {
      type: String,
      required: true
    },
    value: {
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/config.scss';

button {
  border-radius: 16px;
  font-size: 16px;
  color: #ffffff;
  height: 36px;
  padding: 0px 32px;
  border: none;
  @include shadow();
  @include linearGradient(rgba(58, 134, 190, 1), rgba(79, 193, 211, 1));
  transition: box-shadow 0.5s ease;
}

button.gradient-donapp {
  @include donappGradient();
}

button.gradient-user {
  @include userGradient();
}

button.gradient-merchant {
  @include merchantGradient();
}

button.gradient-npo {
  @include npoGradient();
}

button.btn-sm {
  @include borderRadius();
  @include normalFontSize();
  color: #ffffff;
  min-width: 128px;
  height: 32px;
  line-height: 16px;
  padding: 4px 24px;
  margin: 6px 1px;
}

button.disabled {
  cursor: default !important;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.1) !important;
  @include linearGradient(rgb(155, 179, 196), rgb(199, 202, 202));
}
</style>



// WEBPACK FOOTER //
// src/components/shared/buttons/Button.vue